<script setup>
import {ref, onMounted, watch} from "vue";

const props = defineProps({
    resource: {
        type: Object,
        required: true,
    },
});

const embedContainer = ref(null);

const renderEmbed = () => {
    if (!embedContainer.value || !props.resource.embed_code) return;

    embedContainer.value.innerHTML = '';

    const wrapper = document.createElement('div');
    wrapper.innerHTML = props.resource.embed_code;

    const scripts = wrapper.querySelectorAll('script');
    const nonScriptContent = props.resource.embed_code.replace(/<script[\s\S]*?<\/script>/gi, '');

    embedContainer.value.innerHTML = nonScriptContent;

    scripts.forEach(script => {
        const newScript = document.createElement('script');
        if (script.src) {
            newScript.src = script.src;
        } else {
            newScript.textContent = script.textContent;
        }
        Array.from(script.attributes).forEach(attr => {
            if (attr.name !== 'src') {
                newScript.setAttribute(attr.name, attr.value);
            }
        });
        embedContainer.value.appendChild(newScript);
    });
};

onMounted(() => {
    renderEmbed();
});

watch(() => props.resource.embed_code, () => {
    renderEmbed();
});
</script>

<template>
    <div>
        <div ref="embedContainer"></div>
    </div>
</template>
